"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Phone;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Phone(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Contact"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "phone"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M17.5,92.5a6.221,6.221,0,0,1-6.09-4.845L7.661,71.4a6.243,6.243,0,0,1,3.628-7.149l17.5-7.5a6.279,6.279,0,0,1,7.3,1.788l6.492,7.935a55.265,55.265,0,0,0,23.9-23.9l-7.937-6.493a6.278,6.278,0,0,1-1.787-7.3l7.5-17.5a6.243,6.243,0,0,1,7.15-3.628l16.25,3.75A6.217,6.217,0,0,1,92.5,17.5,75.085,75.085,0,0,1,17.5,92.5ZM31.247,61.251a1.239,1.239,0,0,0-.49.1l-17.5,7.5a1.248,1.248,0,0,0-.726,1.429l3.749,16.251A1.245,1.245,0,0,0,17.5,87.5a70.079,70.079,0,0,0,70-70,1.242,1.242,0,0,0-.968-1.217L70.28,12.532a1.249,1.249,0,0,0-1.429.726l-7.5,17.5a1.254,1.254,0,0,0,.357,1.459l9.472,7.75a2.5,2.5,0,0,1,.68,3,60.254,60.254,0,0,1-28.9,28.9,2.5,2.5,0,0,1-3-.68l-7.749-9.471A1.257,1.257,0,0,0,31.247,61.251Z"
  }))));
}